export default "__VITE_PUBLIC_ASSET__1375c9b9__"